import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Form, Spinner } from "react-bootstrap";
import { FaFileExport, FaPrint, FaFilter, FaSearch } from "react-icons/fa";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import "./CustomerList.css";
import api from "../services/api";

const StockReport = () => {
  const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
  const [search, setSearch] = useState("");
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    transactionType: "all",
    name: ""
  });

   const fetchDeliveryNotes = async () => {
    try {
      // setLoading(true);
      // setError("");
      const response = await api.post("/stock_list_wire.php", {});
      
      if (response.data.head.code === 200) {
        setReports(response.data.body);
      } else {
        // setError(response.data.head.msg || "Failed to fetch delivery notes");
        setReports([]);
      }
    } catch (err) {
      console.error("Error fetching delivery notes:", err);
      // setError("Failed to load delivery notes. Please try again.");
      setReports([]);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
      fetchDeliveryNotes();
    }, []);

  // Simulate loading data
  useEffect(() => {
    // Simulate API call delay
    const timer = setTimeout(() => {
      // setReports(dummyReports);
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const applyFilters = () => {
    setLoading(true);
    // Simulate filter processing
    setTimeout(() => {
      // In real implementation, this would filter the data
      // For now, we'll just show all data
      setLoading(false);
    }, 300);
  };

  const resetFilters = () => {
    setFilters({
      startDate: "",
      endDate: "",
      transactionType: "all",
      name: ""
    });
    setSearch("");
  };

  const exportToCSV = () => {
    // Create CSV content
    const headers = ["Date", "Opening Balance", "Name", "Product", "Receipt", "Issue", "CB", "Amount", "Remarks"];
    const csvContent = [
      headers.join(","),
      ...reports.map(r => [
        r.date,
        r.opening_balance,
        r.name,
        r.product,
        r.receipt,
        r.issue,
        r.closing_balance,
        r.amount,
        `"${r.remarks}"`
      ].join(","))
    ].join("\n");

    // Create and trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `workallotment-report-${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    alert("CSV file downloaded successfully!");
  };

  const printReport = () => {
    const printContent = document.querySelector('.table-pagination-content').innerHTML;
    const originalContent = document.body.innerHTML;
    
    document.body.innerHTML = `
      <html>
        <head>
          <title>Work Allotment Report</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
            .text-success { color: green; }
            .text-danger { color: red; }
            .total-row { font-weight: bold; background-color: #f5f5f5; }
            h1 { text-align: center; margin-bottom: 20px; }
            .print-date { text-align: right; margin-bottom: 20px; }
          </style>
        </head>
        <body>
          <h1>Work Allotment Report</h1>
          <div class="print-date">Printed on: ${new Date().toLocaleDateString()}</div>
          ${printContent}
          <script>
            window.onload = function() {
              window.print();
              setTimeout(function() {
                window.close();
              }, 100);
            }
          </script>
        </body>
      </html>
    `;
  };

  const parseDDMMYYYY = (dateStr) => {
  if (!dateStr) return null;
  const [day, month, year] = dateStr.split("-");
  return new Date(year, month - 1, day);
};

const parseYYYYMMDD = (dateStr) => {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split("-");
  return new Date(year, month - 1, day);
};

/*
const filteredReports = reports.filter((report) => {
  // Search filter
  const matchesSearch =
    !searchTerm ||
    report.product_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    report.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    report.supplier_name?.toLowerCase().includes(searchTerm.toLowerCase());

  // Date filter
  const reportDate = parseDDMMYYYY(report.date);
  const from = fromDate ? parseYYYYMMDD(fromDate) : null;
  const to = toDate ? parseYYYYMMDD(toDate) : null;

  if (to) to.setHours(23, 59, 59, 999);

  const matchesDate =
    (!from || reportDate >= from) &&
    (!to || reportDate <= to);

  return matchesSearch && matchesDate;
});
// const sortedReports = [...filteredReports].sort(
//   (a, b) => parseDDMMYYYY(a.date) - parseDDMMYYYY(b.date)
// );
let runningStock = 0;

const reportsWithBalance = filteredReports.map((report) => {
  const openingStock = runningStock;

  let receipt = 0;
  let issue = 0;

  if (report.supplier_id > 0 || report.return_worker_id > 0) {
    receipt = Number(report.stock_qty);
    runningStock += receipt;
  } else if (report.customer_id > 0 || report.worker_id > 0) {
    issue = Number(report.stock_qty);
    runningStock -= issue;
  }

  return {
    ...report,
    open_stock_calc: openingStock,
    receipt_calc: receipt,
    issue_calc: issue,
    close_stock_calc: runningStock
  };
});
*/
// 1. First, sort ALL reports by date (oldest to newest) to ensure math is linear
const allSortedReports = [...reports].sort(
  (a, b) => parseDDMMYYYY(a.date) - parseDDMMYYYY(b.date)
);

// 2. Define our date boundaries
const from = fromDate ? parseYYYYMMDD(fromDate) : null;
const to = toDate ? parseYYYYMMDD(toDate) : null;
if (to) to.setHours(23, 59, 59, 999);

// 3. Calculate "Initial Balance" (Everything before the 'From Date')
let globalRunningStock = 0;

allSortedReports.forEach((report) => {
  const reportDate = parseDDMMYYYY(report.date);
  
  // If this record is BEFORE our filter range, add it to the starting balance
  if (from && reportDate < from) {
    const qty = Number(report.stock_qty);
    if (report.supplier_id > 0 || report.return_worker_id > 0) {
      globalRunningStock += qty;
    } else if (report.customer_id > 0 || report.worker_id > 0) {
      globalRunningStock -= qty;
    }
  }
});

// 4. Now filter the reports for the UI display
const filteredReports = allSortedReports.filter((report) => {
  const matchesSearch =
    !searchTerm ||
    report.product_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    report.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    report.supplier_name?.toLowerCase().includes(searchTerm.toLowerCase());

  const reportDate = parseDDMMYYYY(report.date);
  const matchesDate = (!from || reportDate >= from) && (!to || reportDate <= to);

  return matchesSearch && matchesDate;
});

// 5. Generate the final display list starting from the calculated balance
let currentBalance = globalRunningStock;

const reportsWithBalance = filteredReports.map((report) => {
  const openingStock = currentBalance;
  let receipt = 0;
  let issue = 0;
  const qty = Number(report.stock_qty);

  if (report.supplier_id > 0 || report.return_worker_id > 0) {
    receipt = qty;
    currentBalance += receipt;
  } else if (report.customer_id > 0 || report.worker_id > 0) {
    issue = qty;
    currentBalance -= issue;
  }

  return {
    ...report,
    open_stock_calc: openingStock,
    receipt_calc: receipt,
    issue_calc: issue,
    close_stock_calc: currentBalance
  };
});

  // Calculate totals
  const totals = filteredReports.reduce((acc, report) => ({
    totalReceipt: acc.totalReceipt + report.receipt,
    totalIssue: acc.totalIssue + report.issue,
    totalAmount: acc.totalAmount + report.amount,
    totalOpening: filteredReports.length > 0 ? filteredReports[0].opening_balance : 0,
    totalClosing: filteredReports.length > 0 ? filteredReports[filteredReports.length - 1].closing_balance : 0
  }), { totalReceipt: 0, totalIssue: 0, totalAmount: 0, totalOpening: 0, totalClosing: 0 });

  // Pagination hook
  const {
    currentPage,
    totalPages,
    currentItems: currentReports,
    handlePageChange,
    indexOfFirstItem
  } = usePagination(reportsWithBalance, 25);

  if (loading) {
    return (
      <Container fluid className="outer-container my-3">
        <div className="text-center py-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-3">Loading work allotment report...</p>
        </div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid className="outer-container my-3">
        <div className="alert alert-danger" role="alert">
          {error}
          <button className="btn btn-sm btn-outline-danger ms-3" onClick={() => setError(null)}>
            Retry
          </button>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="outer-container my-3">
      <h2 className="text-center mb-3">Wire Stock Report</h2>
      
      {/* Filters and Controls */}
      <div className="filters-section mb-4 p-3 border rounded bg-light">
        <Row className="g-3 align-items-end">
          <Col xs={12} md={3} lg={3}>
            <Form.Group>
              <Form.Label>From Date:</Form.Label>
              <Form.Control
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={3} lg={3}>
            <Form.Group>
              <Form.Label>To Date:</Form.Label>
              <Form.Control
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Form.Group>
          </Col>


          {/* <Col xs={12} md={6} lg={6}>
            <Form.Group>
              <Form.Label>Search</Form.Label>
              <Form.Control
                placeholder="Search Product Name, Customer Name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Form.Group>
          </Col> */}

          
        </Row>
      </div>

      {/* Table Section */}
      <div className="table-pagination-wrapper">
        <div className="table-pagination-content">
          <Table bordered responsive className="table-striped customer-table">
            <thead className="table-dark">
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Opening Stock</th>
                <th>Name</th>
                <th>Product</th>
                <th>Receipt</th>
                <th>Issue</th>
                <th>Closing Stock</th>
                {/* <th>Amount (₹)</th> */}
              </tr>
            </thead>
            <tbody>
  {currentReports.map((report, index) => (
    <tr key={report.id}>
      <td>{indexOfFirstItem + index + 1}</td>

      <td>
        <span className="badge bg-light text-dark">
          {report.date}
        </span>
      </td>

      {/* Opening Stock */}
      <td className={report.open_stock_calc >= 0 ? 'text-success fw-bold' : 'text-danger fw-bold'}>
        {report.open_stock_calc}
      </td>

      {/* Name */}
      {/* <td>
        <div>
          <strong>
            {report.supplier_id !== 0
              ? report.supplier_name
              : report.worker_id !== 0
              ? report.worker_name
              : report.return_worker_id !== 0
              ? report.return_worker_name
              : report.customer_name}
          </strong>

          <div className="small text-muted">
            Type:
            <span
              className={
                report.supplier_id !== 0 || report.return_worker_id !== 0
                  ? "text-success"
                  : "text-danger"
              }
            >
              {" "}
              {report.supplier_id !== 0
                ? "Supplier"
                : report.worker_id !== 0 || report.return_worker_id !== 0
                ? "Job Work"
                : "Customer"}
            </span>
          </div>
        </div>
      </td> */}
      <td>
                    <div>
                      <strong>{report.supplier_id != 0 ? report.supplier_name : report.worker_id != 0 ? report.worker_name : report.return_worker_id != 0 ? report.return_worker_name : report.customer_name}</strong>
                      <div className="small text-muted">
                        Type: <span className={report.supplier_id != 0 || report.return_worker_id != 0 ? 'text-success' : 'text-danger'}>
                          {report.supplier_id != 0 ? 'Supplier' : report.worker_id != 0 || report.return_worker_id != 0 ? 'Job Work' : 'Customer'}
                        </span>
                      </div>
                   
                    </div>
                  </td>

      {/* Product */}
      <td>
        <span className="badge bg-info text-dark">
          {report.product_name}
        </span>
      </td>

      {/* Receipt */}
      <td className="text-success fw-bold">
        {report.receipt_calc > 0 ? (
          <div className="d-flex align-items-center">
            <span className="me-1">↑</span>
            {report.receipt_calc}
          </div>
        ) : "-"}
      </td>

      {/* Issue */}
      <td className="text-danger fw-bold">
        {report.issue_calc > 0 ? (
          <div className="d-flex align-items-center">
            <span className="me-1">↓</span>
            {report.issue_calc}
          </div>
        ) : "-"}
      </td>

      {/* Closing Stock */}
      <td className={report.close_stock_calc >= 0 ? 'text-success fw-bold' : 'text-danger fw-bold'}>
        {report.close_stock_calc}
      </td>
    </tr>
  ))}

  {currentReports.length === 0 && (
    <tr>
      <td colSpan="8" className="text-center py-4">
        No reports found
      </td>
    </tr>
  )}
</tbody>
            {/* <tbody>
              {currentReports.map((report, index) => (
                <tr key={report.id}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>
                    <span className="badge bg-light text-dark">
                     {report.date}
                    </span>
                  </td>
                  <td className={report.open_stock >= 0 ? 'text-success fw-bold' : 'text-danger fw-bold'}>
                    {report.open_stock}
                  </td>
                  <td>
                    <div>
                      <strong>{report.supplier_id != 0 ? report.supplier_name : report.worker_id != 0 ? report.worker_name : report.return_worker_id != 0 ? report.return_worker_name : report.customer_name}</strong>
                      <div className="small text-muted">
                        Type: <span className={report.supplier_id != 0 || report.return_worker_id != 0 ? 'text-success' : 'text-danger'}>
                          {report.supplier_id != 0 ? 'Supplier' : report.worker_id != 0 || report.return_worker_id != 0 ? 'Job Work' : 'Customer'}
                        </span>
                      </div>
                   
                    </div>
                  </td>
                  <td>
                    <span className="badge bg-info text-dark">
                      {report.product_name}
                    </span>
                  </td>
                  <td className="text-success fw-bold">
                    {report.supplier_id > 0 || report.return_worker_id > 0 ? (
                      <div className="d-flex align-items-center">
                        <span className="me-1">↑</span>
                        {report.stock_qty}
                      </div>
                    ) : '-'}
                  </td>
                  <td className="text-danger fw-bold">
                    {report.customer_id > 0 || report.worker_id > 0 ? (
                      <div className="d-flex align-items-center">
                        <span className="me-1">↓</span>
                        {report.stock_qty.toLocaleString('en-IN')}
                      </div>
                    ) : '-'}
                  </td>
                  <td className={report.close_stock >= 0 ? 'text-success fw-bold' : 'text-danger fw-bold'}>
                    {report.close_stock}
                  </td>
                 
                </tr>
              ))}
              {currentReports.length === 0 && (
                <tr>
                  <td colSpan="9" className="text-center py-4">
                    <div className="text-muted">
                      <FaSearch className="mb-2" size={24} />
                      <p className="mb-0">
                        {search || Object.values(filters).some(f => f) 
                          ? "No reports found matching your criteria" 
                          : "No reports available"}
                      </p>
                      <button 
                        className="btn btn-sm btn-outline-primary mt-2"
                        onClick={resetFilters}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody> */}
            
          </Table>
        </div>
      </div>

      {/* Statistics */}
      {currentReports.length > 0 && (
        <Row className="mt-3">
          <Col>
            <div className="bg-light p-3 rounded">
              <h6>Report Statistics:</h6>
              <div className="d-flex flex-wrap gap-3">
                <div className="stat-item">
                  <span className="text-muted">Total Records:</span>
                  <strong className="ms-2">{filteredReports.length}</strong>
                </div>
                <div className="stat-item">
                  <span className="text-muted">Receipt Transactions:</span>
                  <strong className="ms-2 text-success">
                    {filteredReports.filter(r => r.transaction_type === 'receipt').length}
                  </strong>
                </div>
                <div className="stat-item">
                  <span className="text-muted">Issue Transactions:</span>
                  <strong className="ms-2 text-danger">
                    {filteredReports.filter(r => r.transaction_type === 'issue').length}
                  </strong>
                </div>
                <div className="stat-item">
                  <span className="text-muted">Date Range:</span>
                  <strong className="ms-2">
                    {filteredReports.length > 0 
                      ? `${new Date(filteredReports[0].date).toLocaleDateString()} - ${new Date(filteredReports[filteredReports.length - 1].date).toLocaleDateString()}`
                      : 'N/A'}
                  </strong>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="mt-4">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </Container>
  );
};

export default StockReport;

/*
import React, { useState } from "react";
import { Container, Row, Col, Table, Form, Button, Badge, Card } from "react-bootstrap";
import { FaEye, FaPrint, FaDownload, FaBox, FaExclamationTriangle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import "./CustomerList.css";
import * as XLSX from 'xlsx';

const StockReport = () => {
  const [search, setSearch] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [stockStatusFilter, setStockStatusFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Sample stock data - Fixed soldStock field consistency
  const [stockItems, setStockItems] = useState([
    {
      id: 1,
      productCode: "PB004",
      productName: "Pin Box - (00:4)",
      category: "Packaging",
      currentStock: 73,
      soldStock: 27,
      minStock: 50,
      maxStock: 200,
      unit: "pcs",
      purchaseRate: 180.00,
      sellingRate: 200.00,
      lastPurchaseDate: "2025-11-21",
      supplier: "SSS Enterprises"
    },
    {
      id: 2,
      productCode: "GT003R",
      productName: "3 Inches Gum Tape - Red",
      category: "Tape",
      currentStock: 25,
      soldStock: 10, // Fixed: changed from soldstock to soldStock
      minStock: 30,
      maxStock: 100,
      unit: "rolls",
      purchaseRate: 75.00,
      sellingRate: 85.00,
      lastPurchaseDate: "2025-11-20",
      supplier: "ABC Suppliers"
    },
    {
      id: 3,
      productCode: "GT003O",
      productName: "3 Inches Gum Tape - Orange",
      category: "Tape",
      currentStock: 45,
      soldStock: 5,
      minStock: 30,
      maxStock: 100,
      unit: "rolls",
      purchaseRate: 70.00,
      sellingRate: 80.00,
      lastPurchaseDate: "2025-11-19",
      supplier: "XYZ Traders"
    },
    {
      id: 4,
      productCode: "GT003Y",
      productName: "3 Inches Gum Tape - Yellow",
      category: "Tape",
      currentStock: 15,
      soldStock: 20,
      minStock: 30,
      maxStock: 100,
      unit: "rolls",
      purchaseRate: 65.00,
      sellingRate: 75.00,
      lastPurchaseDate: "2025-11-18",
      supplier: "Global Imports"
    },
    {
      id: 5,
      productCode: "PB005",
      productName: "Pin Box - (00:5)",
      category: "Packaging",
      currentStock: 120,
      soldStock: 80,
      minStock: 50,
      maxStock: 200,
      unit: "pcs",
      purchaseRate: 190.00,
      sellingRate: 210.00,
      lastPurchaseDate: "2025-11-17",
      supplier: "SSS Enterprises"
    },
    {
      id: 6,
      productCode: "GT004R",
      productName: "4 Inches Gum Tape - Red",
      category: "Tape",
      currentStock: 60,
      soldStock: 15,
      minStock: 20,
      maxStock: 80,
      unit: "rolls",
      purchaseRate: 95.00,
      sellingRate: 110.00,
      lastPurchaseDate: "2025-11-16",
      supplier: "ABC Suppliers"
    },
    {
      id: 7,
      productCode: "GT004O",
      productName: "4 Inches Gum Tape - Orange",
      category: "Tape",
      currentStock: 5,
      soldStock: 10,
      minStock: 20,
      maxStock: 80,
      unit: "rolls",
      purchaseRate: 90.00,
      sellingRate: 105.00,
      lastPurchaseDate: "2025-11-15",
      supplier: "XYZ Traders"
    },
    {
      id: 8,
      productCode: "WR001",
      productName: "Wooden Box - Small",
      category: "Packaging",
      currentStock: 35,
      soldStock: 15,
      minStock: 25,
      maxStock: 100,
      unit: "pcs",
      purchaseRate: 350.00,
      sellingRate: 400.00,
      lastPurchaseDate: "2025-11-14",
      supplier: "Global Imports"
    }
  ]);

  // Get unique categories for filter
  const categories = [...new Set(stockItems.map(item => item.category))];

  // Filter stock items based on search, category, stock status, and date range
  const filteredStockItems = stockItems.filter((item) => {
    if (!search && !categoryFilter && !stockStatusFilter && !fromDate && !toDate) return true;

    const query = search.toLowerCase();
    const matchesSearch =
      item.productCode.toLowerCase().includes(query) ||
      item.productName.toLowerCase().includes(query) ||
      item.supplier.toLowerCase().includes(query);

    // Category filtering
    const matchesCategory = !categoryFilter || item.category === categoryFilter;

    // Stock status filtering
    let matchesStockStatus = true;
    if (stockStatusFilter === "low") {
      matchesStockStatus = item.currentStock <= item.minStock;
    } else if (stockStatusFilter === "out") {
      matchesStockStatus = item.currentStock === 0;
    } else if (stockStatusFilter === "over") {
      matchesStockStatus = item.currentStock > item.maxStock;
    } else if (stockStatusFilter === "normal") {
      matchesStockStatus = item.currentStock > item.minStock && item.currentStock <= item.maxStock;
    }

    // Date range filtering for last purchase date
    const lastPurchaseDate = new Date(item.lastPurchaseDate);
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;

    const matchesDateRange =
      (!from || lastPurchaseDate >= from) &&
      (!to || lastPurchaseDate <= to);

    return matchesSearch && matchesCategory && matchesStockStatus && matchesDateRange;
  });

  // Calculate stock value
  const calculateStockValue = () => {
    return stockItems.reduce((total, item) => {
      return total + (item.currentStock * item.purchaseRate);
    }, 0);
  };

  // Get low stock items
  const getLowStockItems = () => {
    return stockItems.filter(item => item.currentStock <= item.minStock && item.currentStock > 0);
  };

  // Get out of stock items
  const getOutOfStockItems = () => {
    return stockItems.filter(item => item.currentStock === 0);
  };

  // Get overstock items
  const getOverStockItems = () => {
    return stockItems.filter(item => item.currentStock > item.maxStock);
  };

  // Get stock status badge
  const getStockStatusBadge = (item) => {
    if (item.currentStock === 0) {
      return <Badge bg="danger">Out of Stock</Badge>;
    } else if (item.currentStock <= item.minStock) {
      return <Badge bg="warning">Low Stock</Badge>;
    } else if (item.currentStock > item.maxStock) {
      return <Badge bg="info">Overstock</Badge>;
    } else {
      return <Badge bg="success">In Stock</Badge>;
    }
  };

  // Get stock level color
  const getStockLevelColor = (item) => {
    if (item.currentStock === 0) return 'text-danger';
    if (item.currentStock <= item.minStock) return 'text-warning';
    if (item.currentStock > item.maxStock) return 'text-info';
    return 'text-success';
  };

  // Pagination hook
  const {
    currentPage,
    totalPages,
    currentItems: currentStockItems,
    handlePageChange,
    indexOfFirstItem
  } = usePagination(filteredStockItems, 10);

  const handlePrint = () => {
    window.open(`/sds_polytechnic/stockreportprint/all`, '_blank');
  };

  // Enhanced Excel Export Function
  const handleExport = () => {
    // Prepare data for Excel
    const excelData = [
      // Header
      ['STOCK REPORT', '', '', '', '', '', '', '', '', '', '', ''],
      ['Company: SDS POLYTECHNIC', '', '', '', '', '', '', '', '', '', '', ''],
      ['Report Date:', new Date().toLocaleDateString('en-IN'), '', '', '', 'Generated On:', new Date().toLocaleDateString('en-IN'), '', '', '', '', ''],
      ['', '', '', '', '', '', '', '', '', '', '', ''],
      
      // Summary Row
      ['SUMMARY', '', '', '', '', '', '', '', '', '', '', ''],
      ['Total Products:', stockItems.length, 'Total Stock Value:', `₹${calculateStockValue().toFixed(2)}`, 'Low Stock Items:', getLowStockItems().length, 'Out of Stock:', getOutOfStockItems().length, 'Overstock Items:', getOverStockItems().length, 'Total Quantity:', stockItems.reduce((total, item) => total + item.currentStock, 0)],
      ['', '', '', '', '', '', '', '', '', '', '', ''],
      
      // Column Headers
      ['S.No', 'Product Code', 'Product Name', 'Category', 'Current Stock', 'Sold Stock', 'Min Stock', 'Max Stock', 'Unit', 'Purchase Rate (₹)', 'Selling Rate (₹)', 'Stock Value (₹)', 'Status', 'Supplier', 'Last Purchase Date'],
      
      // Stock Items
      ...filteredStockItems.map((item, index) => [
        index + 1,
        item.productCode,
        item.productName,
        item.category,
        item.currentStock,
        item.soldStock,
        item.minStock,
        item.maxStock,
        item.unit,
        item.purchaseRate,
        item.sellingRate,
        (item.currentStock * item.purchaseRate),
        getStockStatusString(item),
        item.supplier,
        item.lastPurchaseDate
      ]),
      
      // Empty row
      ['', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      
      // Summary Statistics
      ['STOCK STATUS SUMMARY', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      ['In Stock:', filteredStockItems.filter(item => getStockStatusString(item) === 'In Stock').length, '', '', '', '', '', '', '', '', '', '', '', ''],
      ['Low Stock:', filteredStockItems.filter(item => getStockStatusString(item) === 'Low Stock').length, '', '', '', '', '', '', '', '', '', '', '', ''],
      ['Out of Stock:', filteredStockItems.filter(item => getStockStatusString(item) === 'Out of Stock').length, '', '', '', '', '', '', '', '', '', '', '', ''],
      ['Overstock:', filteredStockItems.filter(item => getStockStatusString(item) === 'Overstock').length, '', '', '', '', '', '', '', '', '', '', '', ''],
    ];

    // Create workbook and worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(excelData);

    // Style the worksheet
    if (!ws['!merges']) ws['!merges'] = [];
    ws['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 11 } }); // Main title
    ws['!merges'].push({ s: { r: 1, c: 0 }, e: { r: 1, c: 11 } }); // Company name
    ws['!merges'].push({ s: { r: 4, c: 0 }, e: { r: 4, c: 11 } }); // Summary header

    // Set column widths
    ws['!cols'] = [
      { wch: 5 },   // S.No
      { wch: 12 },  // Product Code
      { wch: 25 },  // Product Name
      { wch: 12 },  // Category
      { wch: 12 },  // Current Stock
      { wch: 12 },  // Sold Stock
      { wch: 10 },  // Min Stock
      { wch: 10 },  // Max Stock
      { wch: 8 },   // Unit
      { wch: 15 },  // Purchase Rate
      { wch: 15 },  // Selling Rate
      { wch: 15 },  // Stock Value
      { wch: 12 },  // Status
      { wch: 20 },  // Supplier
      { wch: 15 }   // Last Purchase Date
    ];

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, "Stock Report");

    // Generate and download Excel file
    XLSX.writeFile(wb, `StockReport_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  // Helper function for export
  const getStockStatusString = (item) => {
    if (item.currentStock === 0) return "Out of Stock";
    if (item.currentStock <= item.minStock) return "Low Stock";
    if (item.currentStock > item.maxStock) return "Overstock";
    return "In Stock";
  };

  const clearDateFilter = () => {
    setFromDate("");
    setToDate("");
  };

  const clearAllFilters = () => {
    setSearch("");
    setCategoryFilter("");
    setStockStatusFilter("");
    setFromDate("");
    setToDate("");
  };

  // Helper function to get status string for getStatusClass
  const getStockStatusStringForClass = (item) => {
    if (item.currentStock === 0) return "Out of Stock";
    if (item.currentStock <= item.minStock) return "Low Stock";
    if (item.currentStock > item.maxStock) return "Overstock";
    return "In Stock";
  };

  // Status class function
  const getStatusClass = (status) => {
    const s = String(status || "").toLowerCase();
    if (s === "in stock")
      return "status-badge status-approved";
    if (s === "low stock")
      return "status-badge status-cancelled";
    if (s === "out of stock")
      return "status-badge status-rejected";
    if (s === "overstock")
      return "status-badge status-progress";
    return "status-badge status-default";
  };

  return (
    <Container fluid className="outer-container my-3">
      <h2 className="text-center mb-3">Stock Report</h2>

      
      <Row className="mb-4">
        <Col xs={6} md={2}>
          <Card className="stat-card text-center border-0 bg-primary text-white">
            <Card.Body>
              <h4 className="mb-1">{stockItems.length}</h4>
              <small>Total Products</small>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={6} md={2}>
          <Card className="stat-card text-center border-0 bg-success text-white">
            <Card.Body>
              <h4 className="mb-1">₹{calculateStockValue().toLocaleString('en-IN', { minimumFractionDigits: 2 })}</h4>
              <small>Total Stock Value</small>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={6} md={2}>
          <Card className="stat-card text-center border-0 bg-warning text-dark">
            <Card.Body>
              <h4 className="mb-1">{getLowStockItems().length}</h4>
              <small>Low Stock Items</small>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={6} md={2}>
          <Card className="stat-card text-center border-0 bg-danger text-white">
            <Card.Body>
              <h4 className="mb-1">{getOutOfStockItems().length}</h4>
              <small>Out of Stock</small>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={6} md={2}>
          <Card className="stat-card text-center border-0 bg-info text-white">
            <Card.Body>
              <h4 className="mb-1">{getOverStockItems().length}</h4>
              <small>Overstock Items</small>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={6} md={2}>
          <Card className="stat-card text-center border-0 bg-secondary text-white">
            <Card.Body>
              <h4 className="mb-1">
                {stockItems.reduce((total, item) => total + item.currentStock, 0)}
              </h4>
              <small>Total Quantity</small>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      
      <div className="filters-section mb-4 p-3 border rounded bg-light">
        <Row className="g-3 align-items-end">
          <Col xs={12} md={6} lg={4}>
            <Form.Group>
              <Form.Label>Search Products</Form.Label>
              <Form.Control
                placeholder="Search by product code, name, or supplier"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={3}>
            <Form.Group>
              <Form.Label>Category</Form.Label>
              <Form.Select
                value={categoryFilter}
                onChange={(e) => setCategoryFilter(e.target.value)}
              >
                <option value="">All Categories</option>
                {categories.map((category, index) => (
                  <option key={index} value={category}>{category}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={3}>
            <Form.Group>
              <Form.Label>Stock Status</Form.Label>
              <Form.Select
                value={stockStatusFilter}
                onChange={(e) => setStockStatusFilter(e.target.value)}
              >
                <option value="">All Status</option>
                <option value="low">Low Stock</option>
                <option value="out">Out of Stock</option>
                <option value="over">Overstock</option>
                <option value="normal">Normal Stock</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={3}>
            <Form.Group>
              <Form.Label>From Date</Form.Label>
              <Form.Control
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={3}>
            <Form.Group>
              <Form.Label>To Date</Form.Label>
              <Form.Control
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={2} className="d-flex align-items-end gap-2 me-2">
            <Button
              variant="outline-secondary"
              onClick={clearAllFilters}
              disabled={!search && !categoryFilter && !stockStatusFilter && !fromDate && !toDate}
              className="w-100"
            >
              Clear All
            </Button>
          </Col>

          <Col xs={12} md={6} lg={2} className="d-flex justify-content-md-end gap-2">
            <Button
              variant="outline-primary"
              onClick={handleExport}
              className="d-flex align-items-center"
            >
              <FaDownload className="me-2" /> Excel
            </Button>
            <Button
              variant="outline-secondary"
              onClick={handlePrint}
              className="d-flex align-items-center"
            >
              <FaPrint className="me-2" /> Print
            </Button>
          </Col>
        </Row>
      </div>

      
      {(getLowStockItems().length > 0 || getOutOfStockItems().length > 0) && (
        <Row className="mb-3">
          <Col xs={12}>
            <div className="p-3 border rounded bg-warning bg-opacity-10">
              <h6 className="mb-2">
                <FaExclamationTriangle className="me-2 text-warning" />
                Stock Alerts
              </h6>
              <Row>
                {getOutOfStockItems().length > 0 && (
                  <Col md={6}>
                    <strong className="text-danger">Out of Stock:</strong>
                    <div className="small">
                      {getOutOfStockItems().map(item => item.productName).join(', ')}
                    </div>
                  </Col>
                )}
                {getLowStockItems().length > 0 && (
                  <Col md={6}>
                    <strong className="text-warning">Low Stock:</strong>
                    <div className="small">
                      {getLowStockItems().map(item => item.productName).join(', ')}
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </Col>
        </Row>
      )}

      
      <div className="table-pagination-wrapper">
        <div className="table-pagination-content">
          <Table bordered responsive className="table-striped customer-table">
            <thead className="table-dark">
              <tr>
                <th width="5%">S.No</th>
                <th width="10%">Product Code</th>
                <th width="20%">Product Name</th>
                <th width="8%" className="text-center">Current Stock</th>
                <th width="8%" className="text-center">Sold Stock</th>
                <th width="8%" className="text-center">Unit</th>
                <th width="20%">Status</th>
              </tr>
            </thead>
            <tbody>
              {currentStockItems.map((item, index) => (
                <tr key={item.id}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>
                    <strong>{item.productCode}</strong>
                  </td>
                  <td>
                    <div>
                      <div>{item.productName}</div>
                      <small className="text-muted">{item.supplier}</small>
                    </div>
                  </td>
                  <td className={`text-center fw-bold ${getStockLevelColor(item)}`}>
                    {item.currentStock}
                  </td>
                  <td className="text-center">
                    <strong>{item.soldStock}</strong>
                  </td>
                  <td className="text-center">{item.unit}</td>
                  <td>
                    <span className={getStatusClass(getStockStatusStringForClass(item))}>
                      {getStockStatusStringForClass(item)}
                    </span>
                  </td>
                </tr>
              ))}
              {currentStockItems.length === 0 && (
                <tr>
                  <td colSpan="12" className="text-center py-4">
                    <div className="text-muted">
                      <FaBox size={48} className="mb-3" />
                      <p>No stock items found</p>
                      <small>Try adjusting your search or filters</small>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

     
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}

      
      <Row className="mt-4">
        <Col xs={12}>
          <div className="summary-footer p-3 border rounded bg-light">
            <Row>
              <Col md={3}>
                <strong>Total Products:</strong> {filteredStockItems.length}
              </Col>
              <Col md={3}>
                <strong>Total Stock Value:</strong> ₹{calculateStockValue().toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              </Col>
              <Col md={3}>
                <strong>Low Stock Items:</strong> {getLowStockItems().length}
              </Col>
              <Col md={3}>
                <strong>Report Date:</strong> {new Date().toLocaleDateString('en-IN')}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default StockReport;
*/